module.exports = __webpack_public_path__ + "img/1593.e518a2cb.png";